import type { JSX } from 'react';

interface LogoProps {
  size?: number;
  className?: string;
  title?: string;
}

export function SmartNewsLogo({
  size = 48,
  className,
  title = 'Smart News',
}: LogoProps): JSX.Element {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 100 100"
      className={className}
      role="img"
      aria-label={title}
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>{title}</title>
      <rect x="5" y="5" width="90" height="90" rx="14" fill="#F6F3ED" />
      {/* red masthead bar */}
      <rect x="14" y="16" width="72" height="5" fill="#B8353E" />
      {/* thin rule under masthead */}
      <line x1="14" y1="25" x2="86" y2="25" stroke="#0E0E0E" strokeWidth="0.8" />
      {/* left headline */}
      <rect x="14" y="32" width="30" height="5" fill="#0E0E0E" />
      <line x1="14" y1="42" x2="42" y2="42" stroke="#0E0E0E" strokeWidth="1.5" />
      <line x1="14" y1="47" x2="44" y2="47" stroke="#0E0E0E" strokeWidth="1" opacity="0.55" />
      <line x1="14" y1="52" x2="40" y2="52" stroke="#0E0E0E" strokeWidth="1" opacity="0.55" />
      <line x1="14" y1="57" x2="43" y2="57" stroke="#0E0E0E" strokeWidth="1" opacity="0.55" />
      {/* image placeholder */}
      <rect x="48" y="32" width="38" height="26" fill="#D9D4C9" stroke="#0E0E0E" strokeWidth="0.8" />
      {/* bottom column dividers */}
      <line x1="14" y1="66" x2="86" y2="66" stroke="#0E0E0E" strokeWidth="0.8" />
      <line x1="14" y1="72" x2="46" y2="72" stroke="#0E0E0E" strokeWidth="1" opacity="0.55" />
      <line x1="14" y1="77" x2="46" y2="77" stroke="#0E0E0E" strokeWidth="1" opacity="0.55" />
      <line x1="14" y1="82" x2="44" y2="82" stroke="#0E0E0E" strokeWidth="1" opacity="0.55" />
      <line x1="52" y1="72" x2="86" y2="72" stroke="#0E0E0E" strokeWidth="1" opacity="0.55" />
      <line x1="52" y1="77" x2="86" y2="77" stroke="#0E0E0E" strokeWidth="1" opacity="0.55" />
      <line x1="52" y1="82" x2="84" y2="82" stroke="#0E0E0E" strokeWidth="1" opacity="0.55" />
    </svg>
  );
}
